import { render, staticRenderFns } from "./fancybox.vue?vue&type=template&id=4437e765&"
import script from "./fancybox.vue?vue&type=script&lang=js&"
export * from "./fancybox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports